export const BUTTON_LOADING_DELAY: number = 15000;
